export default __webpack_public_path__ + "static/media/webiner2.73ab3e6c.jpg";